module.exports = __webpack_public_path__ + "static/img/bike.58dcf97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bike.png
// module id = +SOA
// module chunks = 8